#mdr-form-field-section {
  display: flex;
  flex-direction: column;
}

#additional-managed-detection-and-response-form-field {
  --margin-vertical: 6px;
  width: auto;
}

#managed-detection-and-response-service-status {
  width: auto;
  text-align: left;
  margin: 0 0 calc(var(--spacer) * 2) calc(var(--spacer) * 5);
}

gz-radio {
  height: calc(var(--spacer) * 4);
  display: flex;
}

.in-trial-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.trial-started-text {
  height: 24px;
  width: 88px;
  background-color: var(--chart-050-hover);
  border-radius: 16px;
  box-sizing: border-box;
  font-family: 'Montserrat-Regular', 'Montserrat', sans-serif;
  color: var(--main-titles-inputs-600);
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  padding-top: 4px;
  margin-bottom: var(--spacer);
}
